import { jsxs as A, jsx as r } from "react/jsx-runtime";
import { Label as h } from "../Label/index.js";
import t from "./productcard.module.js";
const f = ({
  productName: c,
  gtin: u,
  sapCode: a,
  salesUnit: e,
  baseUnit: s,
  amount: o,
  onClick: l,
  ...i
}) => {
  const d = s === e, m = /* @__PURE__ */ A("div", { className: t.productcard, ...i, children: [
    /* @__PURE__ */ A("div", { className: t.body, children: [
      /* @__PURE__ */ r("div", { className: t.imageWrapper, children: /* @__PURE__ */ r(
        "img",
        {
          className: t.image,
          src: `https://public.keskofiles.com/f/k-ruoka/product/${u}?h=50&auto=format`,
          alt: "",
          "aria-hidden": "true",
          onError: (O) => {
            O.currentTarget.src = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAAyCAMAAAA6Njh3AAABfVBMVEUAAAD////////////////////////f39/j4+Po6Ojq6urt7e3u7u7v7+/w8PDx8fHy8vLy8vLo6Ojp6enr6+vv7+/w8PDr6+vs7Ozu7u7v7+/v7+/r6+vr6+vs7Ozt7e3u7u7u7u7v7+/v7+/s7Ozs7Ozt7e3u7u7u7u7u7u7s7Ozs7Ozt7e3t7e3t7e3s7Ozs7Ozs7Ozs7Ozt7e3t7e3t7e3u7u7s7Ozs7Ozs7Ozt7e3u7u7u7u7u7u7s7Ozt7e3t7e3u7u7u7u7u7u7s7Ozt7e3t7e3u7u7t7e3t7e3t7e3t7e3t7e3t7e3t7e3s7Ozs7Ozt7e3t7e3t7e3u7u7u7u7t7e3t7e3t7e3t7e3t7e3t7e3t7e3t7e3u7u7s7Ozt7e3t7e3t7e3t7e3t7e3t7e3t7e3t7e3u7u7s7Ozt7e3t7e3t7e3t7e3t7e3s7Ozt7e3t7e3t7e3t7e3t7e3t7e3t7e3t7e3t7e3s7Ozt7e3t7e3t7e3t7e3t7e168h/DAAAAfnRSTlMAAQIDBAYHCAkLDA4PEBESExQWFxkfIiYoLDAxMjM1Ojs9Pj9CQ0VKS0xQUVRVVl1eX2BjZGVqa2xtcnV2d3t9gISFhomKkZKYmZqbnZ6fo6SmqqyvsLS6vcLExcfJzc7P0NLV1tfY2tvc3uHm6Onq6+zu8PLz9PX3+Pr8/f6ug0GqAAAAAWJLR0QB/wIt3gAAAdlJREFUGBmdwY1DC2EABvBnVxsKkVErhCIfofnMt+Y0iygy1ZbKSIYZsdZu9/zt7r3dtlvv1e693w97uP+7+ASB3KFlAgH0b9FSjkFZ5zJtK2GoStCRgKIhg47qMJR0fWVDvhsqZihksxRmoOAyhVLfib8UrsG33gKFm8AtCsUofAqlKczD8pbChxD8maBQ6IXl6A8Kd+FL/xYt5ihsF0xayjH40LlMYQqOJIWPYbSXoJDbD8e+TxQm0dYZg5btATTEyrRUh9FG1waFB3B5SCHfjb29prDYARdtgcIr7HROTzXN0pZOtUjTNptq0s8CN0wGYsbxhQHlsM6AvmOaAc1hjAGN45DBQMwokGUgawCeMhAdwBADGQHQ8Ye7MQzuphSB5R09VacHNG3wpUlPaQi36cUYg+2qQS/3IBynl0k4ntFLH2zrlFUOw9FToSyPminKVtCwStkL1FykbAkNGcquoObANiUFDQ7tFyWVg3AsUDYKxyXKFlH3iLKNHtiOfKPsMeoG6SF3EpZTn+nhNOpCP+mhupRMZkx6KGpoeEMlc2i6TiVxNB0zqcCMwmWVCtbgplOBDrfzVDACt/A/+laKoMVz+qajVeQ9fZqPYActntlkW5uZcQ2O/8NNRsPLm+EwAAAAAElFTkSuQmCC";
          }
        }
      ) }),
      /* @__PURE__ */ A("div", { className: t.details, children: [
        /* @__PURE__ */ r("span", { className: t.name, children: c }),
        s && e && /* @__PURE__ */ r("div", { children: /* @__PURE__ */ A(h, { color: "var(--blue-80)", children: [
          o,
          " ",
          d ? e : s,
          " ",
          !d && e && `/ ${e}`
        ] }) })
      ] })
    ] }),
    /* @__PURE__ */ A("div", { className: t.footer, children: [
      /* @__PURE__ */ A("div", { children: [
        "KUPA ",
        /* @__PURE__ */ r("span", { className: t.footertextEmphasis, children: u })
      ] }),
      /* @__PURE__ */ A("div", { children: [
        "SAP ",
        /* @__PURE__ */ r("span", { className: t.footertextEmphasis, children: a })
      ] })
    ] })
  ] });
  return l ? /* @__PURE__ */ r(
    "button",
    {
      className: t.productcardButton,
      onClick: l,
      "aria-label": `${c} ${o} ${s} ${e && `/ ${e}`} KUPA ${u} SAP ${a}`,
      children: m
    }
  ) : m;
};
export {
  f as ProductCard
};
